import React from 'react';
import AiWorkspace from '../../components/ai/AiWorkspace';
import { Box } from '@mui/material';
import AssistantChecklistSection from '../../components/assistant/AssistantChecklistSection';
import { AssistantChat, useAssistant } from '../../components/assistant/AssistantProvider';
import AiFileReader from '../../components/ai/AiFileReader';

export default function AssistantPage() {
  const assistant = useAssistant();
  return (
    <Box sx={{ p: { xs: 0, sm: 0 } }}>
      {assistant?.admin ? <><AssistantChat /><details><summary>Strumenti foto contatore e documenti</summary><AiFileReader /><AiFileReader kind="document" /></details></> : <AiWorkspace />}
      <AssistantChecklistSection mode="page" />
    </Box>
  );
}
